
import {LocationService} from "@/services/location.service";

const state ={
    loading_provinsi: false,
    loading_city: false,
    loading_kecamatan: false,
    provinsi: [],
    city: [],
    kecamatan: []
}

const actions ={
    getProvinsi({commit}){
        commit('setloading', true);
        LocationService.getProvinsi().then(value => {
            commit('setloading', false);
            commit('setprovinsi', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
    getCity({commit},provinceid){
        commit('setloading', true);
        LocationService.getCity(provinceid).then(value => {
            commit('setloading', false);
            commit('setcity', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
    getKecamatan({commit},cityid){
        commit('setloading', true);
        LocationService.getKecamatan(cityid).then(value => {
            commit('setloading', false);
            commit('setkecamatan', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
}

const mutations = {
    setloading(state,load){
        state.loading=load;
    },
    setprovinsi(state,v){
        state.provinsi=v.data;
    },
    setcity(state,v){
        state.city=v.data;
    },
    setkecamatan(state,v){
        state.kecamatan=v.data;
    }
}


export const Location = {
    namespaced: true,
    state,
    actions,
    mutations
};
